// extracted by mini-css-extract-plugin
module.exports = {"appErrorBoundary":"AppErrorBoundary_appErrorBoundary__2nt5U","buttonContainer":"AppErrorBoundary_buttonContainer__QDYzY"};